import { NASP_REPORTING_ACTIONS } from '../actions/naspReportingActions';

// ─── INITIAL STATE ─────────────────────────────────────────────────────────────
const emptyLastUpdate = { user: null, timestamp: null };

const initialState = {
	loading: {
		// report key currently uploading, or null — lets each card show its own
		// spinner without blocking the other
		importFile: null,
		lastResult: null,
		sendEmail:  null,
		lastUpdate: false,
	},
	naspReporting: {
		lastUpdate: {
			ThreeMonthComparison: emptyLastUpdate,
			Cancellations:        emptyLastUpdate,
		},
	},
	error: null,
};

// ─── REDUCER ──────────────────────────────────────────────────────────────────
const NaspReportingReducer = (state = initialState, action) => {
	switch (action.type) {

		// ── Import File ───────────────────────────────────────────────────────
		case NASP_REPORTING_ACTIONS.NR_IMPORT_FILE_REQUEST:
			return { ...state, loading: { ...state.loading, importFile: action.report }, error: null };
		case NASP_REPORTING_ACTIONS.NR_IMPORT_FILE_SUCCESS:
			return { ...state, loading: { ...state.loading, importFile: null } };
		case NASP_REPORTING_ACTIONS.NR_IMPORT_FILE_FAILURE:
			return { ...state, loading: { ...state.loading, importFile: null }, error: action.error };

		// ── Get Last Result ───────────────────────────────────────────────────
		case NASP_REPORTING_ACTIONS.NR_GET_LAST_RESULT_REQUEST:
			return { ...state, loading: { ...state.loading, lastResult: action.report }, error: null };
		case NASP_REPORTING_ACTIONS.NR_GET_LAST_RESULT_SUCCESS:
			return { ...state, loading: { ...state.loading, lastResult: null } };
		case NASP_REPORTING_ACTIONS.NR_GET_LAST_RESULT_FAILURE:
			return { ...state, loading: { ...state.loading, lastResult: null }, error: action.error };

		// ── Send Email ────────────────────────────────────────────────────────
		case NASP_REPORTING_ACTIONS.NR_SEND_EMAIL_REQUEST:
			return { ...state, loading: { ...state.loading, sendEmail: action.report }, error: null };
		case NASP_REPORTING_ACTIONS.NR_SEND_EMAIL_SUCCESS:
			return { ...state, loading: { ...state.loading, sendEmail: null } };
		case NASP_REPORTING_ACTIONS.NR_SEND_EMAIL_FAILURE:
			return { ...state, loading: { ...state.loading, sendEmail: null }, error: action.error };

		// ── Get Last Update ───────────────────────────────────────────────────
		case NASP_REPORTING_ACTIONS.NR_GET_LAST_UPDATE_REQUEST:
			return { ...state, loading: { ...state.loading, lastUpdate: true }, error: null };
		case NASP_REPORTING_ACTIONS.NR_GET_LAST_UPDATE_SUCCESS:
			return {
				...state,
				loading: { ...state.loading, lastUpdate: false },
				naspReporting: {
					...state.naspReporting,
					lastUpdate: {
						ThreeMonthComparison: action.payload?.ThreeMonthComparison ?? emptyLastUpdate,
						Cancellations:        action.payload?.Cancellations ?? emptyLastUpdate,
					},
				},
				error: null,
			};
		case NASP_REPORTING_ACTIONS.NR_GET_LAST_UPDATE_FAILURE:
			return { ...state, loading: { ...state.loading, lastUpdate: false }, error: action.error };

		default:
			return state;
	}
};

export default NaspReportingReducer;
